import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { rejectRequest } from "../../../axios/Eventlog/EventLogApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const CorfirmRejectRequestDialog = ({
  onClose,
  onRefresh,
  formData,
  onCloseDetail,
  onLoadingChange,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleRejectRequest = async () => {
    setIsSubmitting(true);
    onLoadingChange?.(true);
    try {
      const payload = {
        ...formData,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await rejectRequest(payload);
      if (response?.data?.responseCode === 0) {
        onClose();
        onCloseDetail?.();
        toast.success(t("common.reject-successfully"));
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      setIsSubmitting(false);
      onLoadingChange?.(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="warning"
      title={t("common.content-172")}
      subtitle={t("common.confirm-reject-request")}
      confirmText={t("button.confirm")}
      loading={isSubmitting}
      onClose={handleCloseDialog}
      onConfirm={handleRejectRequest}
    />
  );
};

export default CorfirmRejectRequestDialog;
